module.exports = __webpack_public_path__ + "img/personal-portfolio.14397e8b.webp";